import CONSTANTS from "../constants";
import { APIUserRole, APIUserGroup } from '../types/api/user.types';

export interface UserConstructorParams {
  id: string;
  userName: string;
  email: string;
  name: string;
  ullrRole: string;
  roles?: APIUserRole[];
  userGroups?: APIUserGroup[];
  verifiedEmail?: string | null;
  favorites?: Record<string, Record<string, number>>;
  favoriteResorts?: string[];
  preferences?: {
    units?: string;
  };
  mfa?: {
    totp?: {
      isEnabled?: boolean;
    };
  };
}

const generateDefaultPreferences = () => {
  const browserLanguage = (window.navigator as any).userLanguage || window.navigator.language;
  const isUnitedStates = browserLanguage === 'en-US' || browserLanguage === 'en';
  return {
    units: isUnitedStates
      ? CONSTANTS.UNITS.IMPERIAL
      : CONSTANTS.UNITS.METRIC,
  };
};

export default class User {
  favoriteResorts?: string[];
  userName: string;
  email: string;
  name: string;
  roles: APIUserRole[];
  userGroups: APIUserGroup[];
  ullrRole: string;
  verifiedEmail?: string | null;
  id: string;
  favorites?: Record<string, Record<string, number>>;
  preferences: { units: string };
  mfa: { totp: { isEnabled?: boolean } };

  constructor({
    favoriteResorts,
    userName,
    email,
    name,
    roles,
    userGroups,
    ullrRole,
    verifiedEmail,
    id,
    favorites,
    preferences,
    mfa,
  }: UserConstructorParams) {
    this.favoriteResorts = favoriteResorts;
    this.userName = userName;
    this.email = email;
    this.name = name;
    this.roles = roles || [];
    this.userGroups = userGroups || [];
    this.ullrRole = ullrRole;
    this.verifiedEmail = verifiedEmail;
    this.id = id;
    this.favorites = favorites;
    this.preferences = {
      ...generateDefaultPreferences(),
      ...preferences,
    };
    this.mfa = {
      totp: {
        ...mfa?.totp,
      }
    };
  }

  getRolesForSport(sport: string): APIUserRole[] {
    const newUserRoles = !!this.roles && this.roles.filter(role => {
      return role.sport === sport || role.sport == null;
    });
    return newUserRoles || [];
  }
}
